<template>
  <div>
    <ts-dialog :visible.sync="visible" width="600px" center>
      <div class="mb-2">
        <h2 class="text-xl text-center mb-2">Warning ! You can’t delete a folder with attached projects</h2>
        <h3 class="text-center" v-if="projects.length > 0">
          You have {{ projects.length }} projects attached, please move them <br class="" />before deleting the folder
        </h3>
      </div>
      <div slot="footer" class="flex items-center justify-center">
        <div class="font-semibold">
          <ts-button class="font-semibold mr-4" title="Close" @click="skip">No, cancel</ts-button>
          <ts-button class="font-semibold" title="Close" @click="moveProjects">Move projects</ts-button>
        </div>
      </div>
    </ts-dialog>
  </div>
</template>

<script>
import appSettingsProvider from '@/appsettings';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  data() {
    return {
      loading: false,
      visible: false,
      projects: [],
      form: {
        email: '',
        message: ''
      }
    };
  },
  computed: {
    ...mapState('workflow', {
      project: state => state.currentProject.value
    })
  },
  validations: {
    form: {
      email: {
        required
      },
      message: {}
    }
  },
  methods: {
    moveProjects() {
      window.EventBus.$emit('folders.move', this.projects);
      this.skip();
    },
    handleOpenDialogButtonClick() {
      this.visible = true;
    },
    resetForm() {
      this.projects = [];
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    handleSaveClick() {}
  },
  async mounted() {
    window.EventBus.$on('folder.archive.prevent', projects => {
      this.projects = [];
      this.projects = projects || [];
      this.handleOpenDialogButtonClick();
    });
  }
};
</script>

<style lang="scss" scoped>
.text-xl {
  font-size: 1.3rem;
}
.text-center {
  text-align: center;
}
.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.cursor-pointer {
  cursor: pointer;
}
.mr-4 {
  margin-right: 1rem;
}
</style>